import _ from "lodash";

const initBoard = () => {
  // Create cell data shape
  const cellDataShape = () => {
    return {
      revealed: false,
      flagged: false,
      isMine: false,
      neighborMines: 0,
    };
  };
  // Initialize empty 2D array
  let arr = [];
  for (let i = 0; i < 8; i++) {
    arr[i] = [];
    for (let j = 0; j < 8; j++) {
      arr[i][j] = cellDataShape();
    }
  }
  // Plant mines
  let mines = 10;
  while (mines > 0) {
    const x = _.random(0, 7);
    const y = _.random(0, 7);
    if (!arr[x][y].isMine) {
      mines -= 1;
      arr[x][y].isMine = true;
    }
  }
  // Count neighboring mines
  for (let i = 0; i < 8; i++) {
    for (let j = 0; j < 8; j++) {
      if (!arr[i][j].isMine) {
        let mines = 0;
        let x1 = Math.max(0, i - 1);
        let x2 = Math.min(7, i + 1);
        let y1 = Math.max(0, j - 1);
        let y2 = Math.min(7, j + 1);
        for (let x = x1; x <= x2; x++) {
          for (let y = y1; y <= y2; y++) {
            if (arr[x][y].isMine) {
              mines += 1;
            }
          }
        }
        arr[i][j].neighborMines = mines;
      }
    }
  }

  return arr;
};

const revealEmpty = (board, x, y) => {
  let x1 = Math.max(0, x - 1);
  let x2 = Math.min(7, x + 1);
  let y1 = Math.max(0, y - 1);
  let y2 = Math.min(7, y + 1);
  for (let i = x1; i <= x2; i++) {
    for (let j = y1; j <= y2; j++) {
      if (board[i][j].neighborMines === 0 && !board[i][j].revealed) {
        board[i][j].revealed = true;
        revealEmpty(board, i, j);
      } else if (!board[i][j].revealed) {
        board[i][j].revealed = true;
      }
    }
  }
};

export { initBoard, revealEmpty };
